import React, { createContext, useContext } from 'react';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// Check if the user agent is Prerender. Speedy should be false if so.
const speedy = navigator.userAgent.toLowerCase().indexOf("prerender") === -1;

// Create Emotion caches
const headCache = createCache({
  key: 'head',
  container: document.head,
  speedy: speedy
});

const footerCache = createCache({
  key: 'footer',
  container: document.getElementById('emotion-footer-styles'),
  speedy: speedy,
  // stylisPlugins: [(context, content) => console.log(context, content)]
});

// Context to expose caches
const EmotionCacheContext = createContext({
  defaultCache: footerCache,
  caches: {
    headCache,
    footerCache,
  },
});

// Provider to supply caches to the app
export const EmotionCacheProvider = ({ children }) => (
  <EmotionCacheContext.Provider
    value={{
      defaultCache: footerCache,
      caches: {
        headCache,
        footerCache,
      },
    }}
  >
    {children}
  </EmotionCacheContext.Provider>
);

// Hook to access the cache context
export const useEmotionCache = () => useContext(EmotionCacheContext);

// Wrapper to apply the correct cache
export const CacheWrapper = ({ cacheKey = 'headCache', children }) => {
  const { caches, defaultCache } = useEmotionCache();
  const selectedCache = caches[cacheKey] || defaultCache;

  return <CacheProvider value={selectedCache}>{children}</CacheProvider>;
};
